module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.creative && !_vm.loading) ? _c('creative-preview', {
    attrs: {
      "creative": _vm.creative,
      "landingPage": _vm.landingPage,
      "facebookPage": _vm.facebookPage,
      "disabledButtons": true,
      "mobilePreview": _vm.mobilePreview
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42fa8bae"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public-creative-preview/PublicCreativePreview.vue
// module id = 2036
// module chunks = 1